/** @format */

import React, { useEffect, useState, useCallback } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import ApiService from "../../services/apiService";
import { toast } from "react-toastify";
import Loader from "../../elements/Loader";
import { useNavigate, useParams } from "react-router-dom";
import { useDropzone } from 'react-dropzone';
import AddressBookingModal from "../modal/addressBookingModal";

function getLoggedInRole() {
  try {
    const raw = localStorage.getItem('authToken');
    if (!raw) return null;
    const token = JSON.parse(raw);
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.role || null;
  } catch {
    return null;
  }
}

export default function AddUser() {
  const [loading, setLoading] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);
  const [certificatePdf, setCertificatePdf] = useState(null);
  const [aadharFile, setAadharFile] = useState(null);
  const [panFile, setPanFile] = useState(null);
  const [image, setImage] = useState(null);
  const [addresses, setAddresses] = useState([]);
  const [showAddressModal, setShowAddressModal] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [aadharPresignedUrl, setAadharPresignedUrl] = useState(null);
  const [panPresignedUrl, setPanPresignedUrl] = useState(null);
  const [newPassword, setNewPassword] = useState('');
  const [settingPassword, setSettingPassword] = useState(false);
  const isSuperAdmin = getLoggedInRole() === 'superadmin';

  const navigate = useNavigate();
  const [initialValues, setInitialValues] = useState({
    name: "",
    email: "",
    phone: "",
    role: "",
    status:"",
    profileImage: "",
    certificatePdfUrl: "",
    aadharUrl: "",
    panUrl: ""
  });
  const params = useParams();
  const { id } = params;
  const validationSchema = Yup.object().shape({
    name: Yup.string().required(),
    //email: Yup.string().email("Invalid email address"),
    phone: Yup.string()
      .matches(/^\d{10}$/, "Phone number must be exactly 10 digits").required(),
    role: Yup.string().required(),
    status: Yup.string()
  });

  const onDrop = (acceptedFiles) => {
    const file = acceptedFiles[0];
    if (file) {
      setImage(file);
      setImagePreview(URL.createObjectURL(file));
    }
  };
  const { getRootProps, getInputProps } = useDropzone({ onDrop });

  const getCustomerById = useCallback(async () => {
    ApiService.get(`user/${id}`)
      .then((data) => {
        if (data?.result) {
          const {
            name,
            email,
            phone,
            role,
            status,
            profileImage,
            certificateName,
            universityName,
            passingYear,
            certificatePdfUrl,
            aadharUrl,
            panUrl
          } = data?.result;
          setInitialValues({ name, email, phone, role, status, profileImage, certificateName, universityName, passingYear, certificatePdfUrl, aadharUrl, panUrl });

          if (profileImage) {
            setImagePreview(profileImage);
          }
          if (aadharUrl) {
            fetchPresignedUrl(aadharUrl).then(setAadharPresignedUrl);
          }
          if (panUrl) {
            fetchPresignedUrl(panUrl).then(setPanPresignedUrl);
          }
        }
      })
      .catch((err) => {
        //toast.error(err?.response?.data);
        setLoading(false);
      });
  }, [id]);

  const fetchPresignedUrl = async (key) => {
    if (!key) return null;
    try {
      const res = await ApiService.get(`upload/pandit-id-url?key=${encodeURIComponent(key)}`);
      return res?.url || null;
    } catch {
      return null;
    }
  };

  const getUserAddresses = useCallback(async () => {
    if (!id) return;
    try {
      const response = await ApiService.get(`user/address/${id}`);
      setAddresses(response?.data || []);
    } catch (err) {
      setAddresses([]);
    }
  }, [id]);

  useEffect(() => {
    if (id) {
      getCustomerById();
      getUserAddresses();
    }
  }, [id, getCustomerById, getUserAddresses]);

  // Handle form submission
  const onSubmit = async (values, { setSubmitting }) => {
    setLoading(true);

    if (image) {
      const formData = new FormData();
      formData.append('file', image);

      const uploadResponse = await ApiService.post('upload/image', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
      })
      values.profileImage = uploadResponse?.url;
    }
    if (certificatePdf) {
      const formData = new FormData();
      formData.append('file', certificatePdf);

      const uploadResponse = await ApiService.post('upload/pdf', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
      })
      console.log(uploadResponse?.url, 'pdfurl')
      values.certificatePdfUrl = uploadResponse?.url;
    }

    if (aadharFile) {
      const formData = new FormData();
      formData.append('file', aadharFile);
      const uploadResponse = await ApiService.post('upload/pandit-id', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      values.aadharUrl = uploadResponse?.key;
    }

    if (panFile) {
      const formData = new FormData();
      formData.append('file', panFile);
      const uploadResponse = await ApiService.post('upload/pandit-id', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      values.panUrl = uploadResponse?.key;
    }

    if (id) {
        ApiService.put(`user/${id}`, values)
          .then((data) => {
            setLoading(false);
            if (data.msg === 'success') {
              toast.success('User Updated');
              navigate("/users", { replace: true });
            } else {
              toast.error(data?.error?.message);
            }
          })
          .catch((err) => {
            toast.error(err?.response?.data?.msg);
            setLoading(false);
          });
    } else {

        ApiService.post("user", values)
          .then((data) => {
            setLoading(false);
            if (data.msg === 'success') {
              toast.success('User added');
              navigate("/users", { replace: true });
            } else {
              toast.error(data?.error?.message);
            }
          })
          .catch((err) => {
            toast.error(err?.response?.data?.error[0].message);
            setLoading(false);
          });
    }
    setSubmitting(false);
  };

  const handleAddressSubmit = async (payload) => {
    console.log(payload, 'payload')
    await ApiService.post(`user/address`, payload);
    await getUserAddresses();
    toast.success("Address added successfully");
  };

  const handleSetPassword = async () => {
    if (!newPassword || newPassword.length < 8) {
      toast.error('Password must be at least 8 characters');
      return;
    }
    setSettingPassword(true);
    try {
      await ApiService.post('auth/set-password', { email: initialValues.email, password: newPassword });
      toast.success('Password set successfully');
      setNewPassword('');
    } catch (err) {
      toast.error(err?.response?.data?.msg || 'Failed to set password');
    } finally {
      setSettingPassword(false);
    }
  };

  return (
    <div className="row" key={initialValues}>
      {loading && <Loader />}

      <div className="col-xl-8 col-lg-12 offset-md-2">
        <div className="card">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h4 className="card-title">{id ? "Edit" : "Add"} User</h4>
            <button 
              className="btn btn-secondary" 
              onClick={() => navigate('/users')}
            >
              <i className="fa fa-arrow-left me-2"></i>
              Back to Users
            </button>
          </div>
          <div className="card-body">
            <div className="basic-form">
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
                enableReinitialize={true}
              >
                {({ isSubmitting, values }) => (
                  <Form>
                    <div className="row">
                      

                        <div className="mb-3 col-md-6">
                        <label className="form-label"> Name</label>
                        <Field
                            name="name"
                            type="text"
                            className="form-control"
                            placeholder="Name"
                        />
                        <ErrorMessage
                            name="name"
                            component="div"
                            className="error-message"
                        />
                        </div>


                        <div className="mb-3 col-md-6">
                            <label className="form-label"> Email</label>
                            <Field
                            name="email"
                            type="text"
                            className="form-control"
                            placeholder="EMail"
                            />
                            <ErrorMessage
                            name="email"
                            component="div"
                            className="error-message"
                            />
                        </div>
                     

                      <div className="mb-3 col-md-6">
                        <label className="form-label"> phone</label>
                        <Field
                          name="phone"
                          type="text"
                          className="form-control"
                          placeholder="phone"
                        />
                        <ErrorMessage
                          name="phone"
                          component="div"
                          className="error-message"
                        />
                      </div>

                      <div className="mb-3 col-md-6">
                        <label className="form-label"> Role</label>
                        <Field as="select"
                          name="role"
                          type="text"
                          className="form-control"
                          placeholder="Select role"
                        >
                          <option value="">Select role</option>
                          <option value="user">User</option>
                          <option value="pandit">Pandit</option>
                          <option value="admin">Admin</option>
                          <option value="booking_executive">Booking Executive</option>
                          <option value="logistic">Logistic</option>
                          <option value="customer_success">Customer Success</option>
                          <option value="content_creator">Content Writer</option>
                        </Field>
                        <ErrorMessage
                          name="role"
                          component="div"
                          className="error-message"
                        />
                      </div>

                      <div className="mb-3 col-md-6">
                        <label className="form-label"> Status</label>
                        <Field as="select"
                          name="status"
                          type="text"
                          className="form-control"
                          placeholder="Select Status"
                        >
                          <option value="">Select Status</option>
                          <option value="active">Active</option>
                          <option value="inactive">Inactive</option>
                          <option value="pending">Pending</option>
                        </Field>
                        <ErrorMessage
                          name="status"
                          component="div"
                          className="error-message"
                        />
                      </div>

                      <div className="mb-3 col-md-6">
                        <label className="form-label">Profile Image</label>
                        <div {...getRootProps()} className="border border-dashed border-gray-300 p-4 rounded mb-4 cursor-pointer">
                          <input {...getInputProps()} />
                          {imagePreview ? (
                            <img src={imagePreview} alt="Preview" className="max-w-full h-40 object-cover" width={200} height={200} />
                          ) : (
                            <p>Drag 'n' drop an image, or click to select one</p>
                          )}
                        </div>

                      </div>

                      {values.role === 'pandit' && (
                        <>
                          <div className="mb-3 col-md-6">
                            <label className="form-label"> Certificate Name</label>
                            <Field
                                name="certificateName"
                                type="text"
                                className="form-control"
                                placeholder="Certificate Name"
                            />
                            <ErrorMessage
                                name="certificateName"
                                component="div"
                                className="error-message"
                            />
                          </div>
                          <div className="mb-3 col-md-6">
                            <label className="form-label">University Name</label>
                            <Field
                                name="universityName"
                                type="text"
                                className="form-control"
                                placeholder="University Name"
                            />
                            <ErrorMessage
                                name="universityName"
                                component="div"
                                className="error-message"
                            />
                          </div>
                          <div className="mb-3 col-md-6">
                            <label className="form-label">Passing Year</label>
                            <Field
                                name="passingYear"
                                type="text"
                                className="form-control"
                                placeholder="Passing Year"
                            />
                            <ErrorMessage
                                name="passingYear"
                                component="div"
                                className="error-message"
                            />
                          </div>
                          <div className="mb-3 col-md-6">
                            <label className="form-label">Certificate pdf</label>
                            <input
                              name="certificatePdf"
                              type="file"
                              accept="application/pdf"
                              onChange={(event) => {
                                setCertificatePdf(event.currentTarget.files[0])
                              }}
                              className="form-control"
                            />
                            { certificatePdf ? (
                              <p>
                                Selected File: {certificatePdf.name}
                              </p>
                            ) : values?.certificatePdfUrl ? (
                              <p>
                                Existing File:{" "}
                                <a
                                  href={values?.certificatePdfUrl}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  View Certificate PDF
                                </a>
                              </p>
                            ) : (
                              <p>No file chosen</p>
                            )}
                          </div>

                          <div className="mb-3 col-md-6">
                            <label className="form-label">Aadhar Card</label>
                            <input
                              name="aadharFile"
                              type="file"
                              accept="image/*,application/pdf"
                              onChange={(e) => setAadharFile(e.currentTarget.files[0])}
                              className="form-control"
                            />
                            {aadharFile ? (
                              <p className="mt-1 text-muted">Selected: {aadharFile.name}</p>
                            ) : aadharPresignedUrl ? (
                              <p className="mt-1">
                                <a href={aadharPresignedUrl} target="_blank" rel="noopener noreferrer">
                                  View Aadhar
                                </a>
                              </p>
                            ) : values?.aadharUrl ? (
                              <p className="mt-1 text-muted">Loading...</p>
                            ) : (
                              <p className="mt-1 text-muted">No file chosen</p>
                            )}
                          </div>

                          <div className="mb-3 col-md-6">
                            <label className="form-label">PAN Card</label>
                            <input
                              name="panFile"
                              type="file"
                              accept="image/*,application/pdf"
                              onChange={(e) => setPanFile(e.currentTarget.files[0])}
                              className="form-control"
                            />
                            {panFile ? (
                              <p className="mt-1 text-muted">Selected: {panFile.name}</p>
                            ) : panPresignedUrl ? (
                              <p className="mt-1">
                                <a href={panPresignedUrl} target="_blank" rel="noopener noreferrer">
                                  View PAN
                                </a>
                              </p>
                            ) : values?.panUrl ? (
                              <p className="mt-1 text-muted">Loading...</p>
                            ) : (
                              <p className="mt-1 text-muted">No file chosen</p>
                            )}
                          </div>
                        </>
                      )}

                    </div>

                    <button
                      type="submit"
                      disabled={isSubmitting}
                      className="btn btn-primary"
                    >
                      Save
                    </button>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>

      {/* User Address Card */}
      { id && (
        <div className="col-xl-8 col-lg-12 offset-md-2">
          <div className="card mt-4">
            <div className="card-header d-flex justify-content-between align-items-center">
              <h4 className="card-title mb-0">User Addresses</h4>
              <button
                className="btn btn-primary"
                onClick={() => {
                  setSelectedAddress(null);
                  setShowAddressModal(true);
                }}
              >
                Add Address
              </button>
            </div>
            <div className="card-body">
              {addresses.length === 0 ? (
                <p>No addresses found.</p>
              ) : (
                <ul>
                  {addresses.map((addr, idx) => (
                    <li key={idx}>
                      <strong>{addr.fullAddress}</strong>
                      {addr.locality && <> - {addr.locality}</>}
                      {addr.direction && <> ({addr.direction})</>}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>
        </div>
      )}

      {id && isSuperAdmin && (
        <div className="col-xl-8 col-lg-12 offset-md-2">
          <div className="card mt-4">
            <div className="card-header">
              <h4 className="card-title mb-0">Set Password</h4>
            </div>
            <div className="card-body">
              <div className="row align-items-end">
                <div className="mb-3 col-md-8">
                  <label className="form-label">New Password</label>
                  <input
                    type="password"
                    className="form-control"
                    placeholder="Enter new password (min 8 characters)"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                  />
                </div>
                <div className="mb-3 col-md-4">
                  <button
                    className="btn btn-warning w-100"
                    onClick={handleSetPassword}
                    disabled={settingPassword}
                  >
                    {settingPassword ? 'Setting...' : 'Set Password'}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <AddressBookingModal
        showModal={showAddressModal}
        setShowModal={setShowAddressModal}
        bookingId={null}
        userId={id}
        onAddressSubmit={handleAddressSubmit}
        initialAddress={selectedAddress}
      />
    </div>
  );
}
